import React, {useContext, useEffect, useState} from 'react';
import {Link, Navigate, useNavigate} from "react-router-dom";
import logo from '../../assets/images/logo.svg'
import avatar from '../../assets/images/avatar.webp'
import {Button} from "@mui/material";
import './Header.css'
import {RiMenuFold2Fill} from "react-icons/ri";
import {RiMenuFill} from "react-icons/ri";
import {useAuth} from "../context/authContext/AuthContext";
import {doc, getDoc} from "firebase/firestore";
import {db, adminCollectionName} from "../Firebase/Firebase";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Logout from '@mui/icons-material/Logout';
import {SideBarContext} from "../../App";

const Header = () => {
    const {currentUser, logOut} = useAuth();
    const [userInfo, setUserInfo] = useState({email: '', name: ''});

    const navigate = useNavigate();

    const handleNavigateToSignUp = () => {
        navigate('/signUp');
    };

    const sideBarContext = useContext(SideBarContext)

    useEffect(() => {
        const fetchUserInfo = async () => {
            if (currentUser && currentUser.uid) {
                const userDocRef = doc(db, adminCollectionName, currentUser.uid);
                const userDoc = await getDoc(userDocRef);

                if (userDoc.exists()) {
                    setUserInfo(userDoc.data());
                }
            }
        };

        fetchUserInfo();
    }, [currentUser]);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleOpenAccDrop = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseAccDrop = () => {
        setAnchorEl(null);
    };

    const handleLogOut = async () => {
        await logOut();
    };

    return (
        <header className="d-flex align-items-center">
            <div className="container-fluid w-100">
                <div className="row d-flex align-items-center w-100">
                    {/*Logo*/}
                    <div className="col-sm-2 part1">
                        <Link to="/" className="d-flex align-items-center logo">
                            <img src={logo} alt={logo}/>
                            <span className="ml-2">Admin</span>
                        </Link>
                    </div>

                    <div className="col-sm-3 d-flex align-items-center part2 pl-3">
                        <Button
                            className="rounded-circle mr-3"
                            onClick={() => sideBarContext.setIsToggleSidebar(!sideBarContext.isToggleSidebar)}
                        >
                            {
                                sideBarContext.isToggleSidebar === false ?
                                    <RiMenuFold2Fill/> : <RiMenuFill/>
                            }
                        </Button>
                    </div>
                    <div className="col-sm-7 d-flex align-items-center justify-content-end part3">
                        <div className="myAccWrapper">
                            <Button className="myAcc d-flex align-items-center"
                                    onClick={handleOpenAccDrop}
                            >
                                <div className="userImg">
                                <span className="rounded-circle">
                                    <img
                                        src={avatar} alt={avatar}/>
                                </span>
                                </div>

                                <div className="userInfo">
                                    <h4>{userInfo.name || 'Name'}</h4>
                                    <p className="mb-0">{userInfo.email || 'test@mail.com'}</p>
                                </div>
                            </Button>

                            <Menu
                                anchorEl={anchorEl}
                                id="account-menu"
                                open={open}
                                onClose={handleCloseAccDrop}
                                onClick={handleCloseAccDrop}
                                PaperProps={{
                                    elevation: 0,
                                    sx: {
                                        overflow: 'visible',
                                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                        mt: 1.5,
                                        '& .MuiAvatar-root': {
                                            width: 32,
                                            height: 32,
                                            ml: -0.5,
                                            mr: 1,
                                        },
                                        '&::before': {
                                            content: '""',
                                            display: 'block',
                                            position: 'absolute',
                                            top: 0,
                                            right: 14,
                                            width: 10,
                                            height: 10,
                                            bgcolor: 'background.paper',
                                            transform: 'translateY(-50%) rotate(45deg)',
                                            zIndex: 0,
                                        },
                                    },
                                }}
                                transformOrigin={{horizontal: 'right', vertical: 'top'}}
                                anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                            >
                                <MenuItem onClick={handleNavigateToSignUp}>
                                    <ListItemIcon>
                                        <PersonAdd fontSize="small"/>
                                    </ListItemIcon>
                                    Add another account
                                </MenuItem>
                                <MenuItem onClick={handleLogOut}>
                                    <ListItemIcon>
                                        <Logout fontSize="small"/>
                                    </ListItemIcon>
                                    Logout
                                </MenuItem>
                            </Menu>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;